import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_carret",
  "use": "icon-icon_carret-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-icon_carret\">\n    <g opacity=\"1\" transform=\"translate(0 0)  rotate(0 8 8)\">\n        <path id=\"icon-icon_carret_Page 1 Copy\" fill-rule=\"evenodd\" transform=\"translate(4 7.333333333333333)  rotate(0 4 2)\" opacity=\"1\" d=\"M6,6L12,0L0,0L6,6Z \" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol